module.exports = __webpack_public_path__ + "img/Samoa.04953735.svg";